import { render, staticRenderFns } from "./FormOpportunity.vue?vue&type=template&id=bfa9aff0&scoped=true&"
import script from "./FormOpportunity.vue?vue&type=script&lang=js&"
export * from "./FormOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./FormOpportunity.vue?vue&type=style&index=0&id=bfa9aff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa9aff0",
  null
  
)

export default component.exports